import {
  useAppDispatch,
  useAppSelector,
} from "../../redux-store/CustomReduxHooks";
import APIFailurePopup from "../CustomAPIFailurePopup/APIFailurePopup";
import {
  clearError,
  ErrorEventHandler,
} from "../../redux-store/reducers/CsErrorSlice";
import { useCallback, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { triggerCleverTapEvent } from "../../utils/CleverTap";
import { CleverTapEventType } from "../../utils/CleverTapConstant";
import { CT_ScreenEvntDtls } from "../../features/Feature_CleverTap/ScreenEvents/CleverTapEventDetails";
import { SCREEN_TYPE } from "../../utils/constants";
import { R_LiRoutes } from "../../utils/Routes";
import { resetPseudoLoginSlice } from "../../features/Feature_PseudoLogin/PseudoLogin_Slice";

const ErrorComp: React.FC = () => {
  const errorState = useAppSelector((state) => state.CsErrorSlice);
  const authDispatch = useAppDispatch();
  const cmsErrState = useAppSelector(
    (state) => state.CmsSlice.CmsErrorVariablesData,
  );
  const pseudoLoginData = useAppSelector((state) => state.PseudoLoginSlice);
  const location = useLocation();

  useEffect(() => {
    if (errorState.error && location.pathname.includes(R_LiRoutes.li_baseUrl)) {
      triggerCleverTapEvent(CleverTapEventType.SCREEN_EVENT, {
        ScreenName: CT_ScreenEvntDtls.R_LIFE.liPolicyBondSuccess.screenName,
        ScreenType: SCREEN_TYPE.LIScreenType,
      });
    }
  }, [errorState]);

  const handleOpen = useCallback(() => {
    if (ErrorEventHandler.eventState.onClick) {
      ErrorEventHandler.eventState.onClick({ ...errorState });
      ErrorEventHandler.resetHandler();
    }
    authDispatch(clearError());
  }, [errorState]);

  const ApiErrorObj = errorState.error as any;
  const matchedObj = cmsErrState.find(
    (f) => f.attributes?.errorCode === ApiErrorObj?.errorCode,
  );
  const title =
    matchedObj?.attributes?.uiDisplayTitle || ApiErrorObj?.uiDisplayTitle;
  const message =
    matchedObj?.attributes?.uiDisplayMessage || ApiErrorObj?.uiDisplayMessage;

  const apiErrorMessage = useMemo(
    () => ({
      msg: errorState?.message || "",
      stk: JSON.stringify(ApiErrorObj),
      raw: ApiErrorObj,
    }),
    [errorState.error],
  );

  // only log when the error carries actual API response data, not a bare Error object
  const hasApiErrorData = !!(
    ApiErrorObj?.errorCode ||
    ApiErrorObj?.uiDisplayMessage ||
    apiErrorMessage.msg
  );

  const handleLinkExpirePopUpBtnClick = () => {
    authDispatch(resetPseudoLoginSlice());
    authDispatch({ type: "USER_LOGOUT" });
  };

  if (pseudoLoginData.isLinkExpired) {
    return (
      <APIFailurePopup
        open={true}
        handleOpen={handleLinkExpirePopUpBtnClick}
        customTitle={"Oops!"}
        customSubTitle={"This link has expired."}
      />
    );
  }

  return errorState.error ? (
    <APIFailurePopup
      open={true}
      handleOpen={handleOpen}
      customTitle={title}
      customSubTitle={message}
      moduleName="API-Error"
      pageName="ErrorComp"
      errorFromUI={hasApiErrorData}
      errorMessage={apiErrorMessage}
    />
  ) : null;
};

export default ErrorComp;
